/*
 * @Description: 
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2023-08-16 16:03:26
 * @LastEditors: changfeng
 * @LastEditTime: 2024-02-21 11:34:00
 */
// 运行时配置
import { useState } from "react";
import { MenuExtra, MenuHeader , HeaderTitle} from "./components"
import { Link ,history, useModel} from "umi"
import { type MenuDataItem , type Settings as LayoutSettings, PageContainer } from '@ant-design/pro-components';
import defaultSettings from '../config/defaultSettings';
import { getCurrentUser, initJwtToken } from './services/user';

import type { RunTimeLayoutConfig } from '@umijs/max';
import { getAccessToken, MoveTokenFromLocalStorage } from '@/utils/const';
import type { RequestConfig } from 'umi';
import { stringify } from 'querystring';
import { getBcId } from "./services/bussinessCenterConfig";
import { Button, Spin, message as Message } from 'antd';
import { SpinRing } from '@/components/PageLoading';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import localeData from 'dayjs/plugin/localeData';
import WXQRcode from "@/assets/WXQRcode.jpg"
import CustomerServe from "@/components/NavFooter"
import MaintenanceNotice from "@/components/MaintenanceNoticeModal"
import { BRAND_NAME, REGION_LABEL } from "@/utils/region"
import "./global.scss"

// 检测线上是否有新版本，旧版本自动刷新一次。配合 config.ts 的 hash: true 使用。
// 解决用户浏览器缓存了旧 index.html 导致加载到老 JS bundle 的问题。
(async () => {
  try {
    const res = await fetch(`/?_t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;
    const html = await res.text();
    const remote = html.match(/umi\.([a-f0-9]+)\.js/)?.[1];
    if (!remote) return;
    const localScript = Array.from(
      document.querySelectorAll<HTMLScriptElement>('script[src]'),
    ).find((s) => /\/umi\.[a-f0-9]+\.js/.test(s.src));
    const local = localScript?.src.match(/umi\.([a-f0-9]+)\.js/)?.[1];
    if (local && remote && local !== remote) {
      const KEY = '__last_reload_hash__';
      if (sessionStorage.getItem(KEY) !== remote) {
        sessionStorage.setItem(KEY, remote);
        window.location.reload();
      }
    }
  } catch (e) {}
})();

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
// export async function getInitialState(): Promise<{ name: string }> {
//   return { name: '@umijs/max' };
// }

/** 浏览器 tab 标题统一带上「品牌名 · 区域」后缀，方便切多个 tab 时一眼识别 */
;(function applyRegionTitle() {
  const TITLE_SUFFIX = ` · ${REGION_LABEL}`
  const apply = () => {
    const cur = document.title || ''
    const base = cur.replace(/\s*·\s*(国内户|海外户)$/, '').trim() || BRAND_NAME
    const next = base + TITLE_SUFFIX
    if (cur !== next) document.title = next
  }
  apply()
  const titleEl = document.querySelector('title')
  if (titleEl) new MutationObserver(apply).observe(titleEl, { childList: true, subtree: true })
  else new MutationObserver(() => {
    const t = document.querySelector('title')
    if (t) { apply(); new MutationObserver(apply).observe(t, { childList: true, subtree: true }) }
  }).observe(document.head, { childList: true })
})()

/** 入口文件配置dayjs插件 */
dayjs.extend(utc)

dayjs.extend(timezone)
dayjs.extend(weekday)
dayjs.extend(localeData)


/** 全局 Spin 统一为品牌红圆环（表格、局部 loading 一致视觉） */
Spin.setDefaultIndicator(<SpinRing />);

const loginPath = '/login'
const registerPath = '/register'
// 无需登录即可访问的页面
const publicPaths = [loginPath, registerPath, '/privacy', '/findPassword']


export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<any>;
}> {

  if (!initJwtToken() && !publicPaths.includes(location.pathname)) {
    history.push(loginPath)
  }
  const fetchUserInfo = async (token) => {
    try {
      const msg = await getCurrentUser(token);

      if (msg.code === 200) {
        return {
          ...msg.data.user
        }
      } else if (msg.code === 403) {
          history.push('/login')
      } else {
        return {

        };
      }
 
    } catch (error) {
      
      localStorage.removeItem("Authorization")
      sessionStorage.removeItem("Authorization")
      const { search, pathname } = history.location;
       history.replace({
        pathname: loginPath,
        search: stringify({
          redirect: pathname + search,
        }),
      });
    }
    return {
      
    };
  };


  // 如果不是登录页面，执行

  if (
    location.pathname !== loginPath &&
    location.pathname !== registerPath &&
    location.pathname !== '/privacy' &&
    location.pathname !== '/findPassword' &&
    location.pathname !== '/findPassword'
  ) {
    const userInfo = await fetchUserInfo();


    return {
      fetchUserInfo,
      currentUser: userInfo,
      settings: defaultSettings,
    }
  } else {
    return {
      fetchUserInfo,
      currentUser:{},
      settings: defaultSettings,
    };
  }
 
}

export const layout:RunTimeLayoutConfig = ({
  initialState
}) => {

  const [collapsed, setCollapsed] = useState<boolean>(false)
  
  return {
    // pure:true,
    logo: false,
    title: false,
    collapsed:collapsed,
    menuHeaderRender: () => <MenuHeader collapsed={collapsed} setSideExpension={(value) => setCollapsed(value)} />,
    menuExtraRender: () => <MenuExtra collapsed={collapsed}   />,
    // menuRender: (props) => {

    //   return <h1>1234</h1>
    // },
    menuItemRender: (item: MenuDataItem, dom: React.ReactNode) => {
      return <Link
        style={{ color: "#fff",paddingLeft:collapsed ? 0 : '20px',display:'block'}}
        to={item.path}
        className={location.pathname === item.path ? collapsed ? 'collpasedActiveLink': 'activeLink':''}
       
      >{dom}</Link>
    },
    onMenuHeaderClick: () => {
      console.log("123456789")
    },
    menuDataRender: (menuData) => {
      return menuData
    },
    // menuRender: (menu) => {
    //   console.log('menu', menu)
    //   const { menuData } = menu
    //   return <div>
    //     {
    //       menuData?.map(item => <Link>111</Link>)
    //     }
    //   </div>
    // },
    menuFooterRender: () => <div style={{ width: '100%',color:'#fff' }}>
      {/* {
       !collapsed && <div>
        <span style={{textAlign:'center',display:'inline-block',width:'100%'}}>联系客服</span><br />
          <span style={{ textAlign: 'center', display: 'inline-block', width: '100%' }}>请用微信扫一扫</span>
        </div>
      }
      <img onClick={() => setCollapsed(false)}  src={WXQRcode} style={{width:'100%',marginTop:10}} /> */}
     <CustomerServe  />
    </div>,
    menuProps: {
      onClick:() => setCollapsed(false)
    },
    headerRender: false,
    pageTitleRender: null,
    headerContentRender:null,
    // avatarProps: () => <div>345</div>,
    actionsRender:() => [],
    menu: {
      locale: false,
    },
    // breadcrumbRender: (route) => {
    //   console.log('breadcrumb', route)
    //   return route
    // },
    childrenRender: (children) => {
      return (
        <PageContainer title={<HeaderTitle />} breadcrumb={false}>
          {/*<MaintenanceNotice />*/}
          {children}
        </PageContainer>
      );
      // return children
    },
    ...defaultSettings,
    // route:menus

  };
};




// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}


const paramsSerializer = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams();

  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value === null || value === undefined) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== null && item !== undefined) {
          searchParams.append(key, String(item));
        }
      });
      return;
    }
    searchParams.append(key, String(value));
  });

  return searchParams.toString();
};

export const request: RequestConfig = {
  timeout: 300000,

  headers: { 'X-Requested-With': 'XMLHttpRequest' },

  paramsSerializer,

  // other axios options you want
  errorConfig: {

    errorHandler(error: any, options: any) {
      if (options?.skipErrorHandler) throw error;
      const { response = {}, message } = error;
      const { status = null } = response;
      if (String(response) !== '{}' && response.status) {
        const errorText = response.statusText;
        const msg = response.data.message || message;
        // 401时回到登录页面
        if (status === 401) {
          Message.warning('您未登录或登录信息已过期，请重新登陆!');
          // 清除token
          console.log('123456789',123)
           MoveTokenFromLocalStorage();
          // ...跳转到登录页面。
          // history.push(loginPath)
          const { search, pathname } = history.location;
          console.log('search, pathname ',search, pathname )
          history.replace({
            pathname: loginPath,
            search: stringify({
              redirect: pathname + search,
            }),
          });
        } else {
          Message.error(msg || errorText || `请求错误 [${status}]`);
        }
      } else {
        Message.error(message || '您的网络发生异常，无法连接服务器');
      }
      error.response = {
        message: error.message,
      };
      return Promise.reject(error);
    },

  //   errorThrower: (res: ResponseStructure) => {
  //     console.log('res',res)
  //     const { success, data, errorCode, errorMessage, showType } = res;
  //     if (!success) {
  //       const error: any = new Error(errorMessage);
  //       // error.name = 'BizError';
  //       error.info = { errorCode, errorMessage, showType, data };
  //       console.log('eeeeeee',error)
  //       throw Promise.reject(error); // 抛出自制的错误
  //     }
  //   },
  },
  requestInterceptors: [
    (url, options) => {
      return {
        url,
        options: {
          ...options,
          // params: { ...options.params, bc_id: getBcId() },
          params: { ...options.params },
          headers: {
            // token: getAccessToken(),
            token: getAccessToken(),
            bcType: getBcId()
          },
        },
      };
    },
  ],
  responseInterceptors: [
    (response: any) => {
      const { data = {}}: { url: string; status: number; data: any } =
        response;
      if (toString.call(data) === '[object Blob]') {
        return response
      } else {
        const { code, message } = data;
        /** 接口请求成功，做错误拦截 */
        if (code !== 200 && code !== 4003) {
        
          if (code === 401) {

            Message.warning('您未登录或登录信息已过期，请重新登陆!');
            // 清除token

            MoveTokenFromLocalStorage();
            const { search, pathname } = history.location;
          history.replace({
            pathname: loginPath,
            search: stringify({
              redirect: pathname + search,
            }),
          });
          } else {
            Message.error(message);
          }
          return {
            data: {
              message: message,
              success: false,
            },
          };
        }
        return response;
      }
   
    },
  ],
};
